import { useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import type { Languages } from '../../i18n/i18n.language-config';
import { FEATURE_FLAG_KEYS } from '../../config/growthbook';
import { getPlatformRegion } from '../app.utils';

export const usePlatformLanguage = (): Languages => {
  const ukEnvironment = useFeature(FEATURE_FLAG_KEYS.UK_ENVIRONMENT);
  const auEnvironment = useFeature(FEATURE_FLAG_KEYS.AU_ENVIRONMENT);

  return useMemo(
    () =>
      getPlatformRegion({
        ukEnvironment: ukEnvironment.on,
        auEnvironment: auEnvironment.on,
      }),
    [ukEnvironment.on, auEnvironment.on]
  );
};
